<template>
  <div class="ma-4 px-4">
    <div class="my-2">
      <v-sheet outlined>
        <v-data-table
          :headers="degreeHeaders"
          :items="degrees"
          fixed-header
          hide-default-footer
          class="secondary row-height-50"
        >
          <template #[`item.action`]="{ item }">
            <v-icon
              :disabled="!item.active"
              small
              class="mr-2"
              color="accent"
              @click="editDegree(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <template #[`item.level`]="{ item }">
            {{ showLevel(item) }}
          </template>
          <template #[`item.active`]="{ item }">
            <v-chip
              small
              :color="item.active ? 'green' : 'red'"
              dark
              @click="openConfirm('D', item)"
            >
              {{ showActiveStatus(item) }}
            </v-chip>
          </template>
        </v-data-table>
      </v-sheet>
    </div>
    <div class="my-6">
      <span class="text-5xl font-weight-bold accent--text"> PROGRAMS </span>
    </div>
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="programHeaders"
            :search="search"
            :items="programs"
            fixed-header
            :custom-filter="customFilter"
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                :disabled="!item.active"
                small
                class="mr-2"
                color="accent"
                @click="edit(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.degree_specialization`]="{ item }">
              {{ getProgramName(item) }}
            </template>
            <template #[`item.duration`]="{ item }">
              {{ getDurationType(item) }}
            </template>
            <template #[`item.department`]="{ item }">
              {{ item.department?.name }}
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm('P', item)"
              >
                {{ showActiveStatus(item) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createProgram"
        @update="updateProgram"
        :degrees="degrees"
        :degree_id="parseInt(degree_id)"
        :departments="departments"
        :program="program"
        :edit="editMode"
      />
    </v-dialog>
    <v-dialog v-model="degreeDialog" width="800" persistent scrollable>
      <formDegreeDialog
        v-if="degreeDialog"
        @closeDialog="degreeDialog = false"
        @update="updateDegree"
        :degree="degree"
        :edit="editDegreeMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      :title="key == 'D' ? 'degree' : 'program'"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/program/form.vue";
import formDegreeDialog from "@/components/degree/form.vue";
import searchBar from "@/components/searchBar.vue";
import ConfirmDialog from "@/components/confirm.vue";
import {
  degreeHeaders,
  departmentHeaders,
  programHeaders,
} from "@/constants/headers";
import { durations, levels } from "@/constants/enum";
export default {
  components: {
    formDialog,
    formDegreeDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      degreeDialog: false,
      editMode: false,
      program: {},
      degree: {},
      degree_id: null,
      programs: [],
      search: "",
      degrees: [],
      degreeHeaders: degreeHeaders,
      programHeaders: programHeaders,
      headers: departmentHeaders,
      levels: levels,
      degrees: [],
      departments: [],
      durations: durations,
      showDialog: false,
      currentItem: {},
      key: null,
    };
  },
  watch: {},
  computed: {},
  async created() {
    await this.initialise();
    this.degree_id = this.$route.params.id;
    const title = this.$route.query.name;
    this.$store.commit("setBreadcrumbs", [
      { text: "Degree", to: { name: "Degree" } },
      { text: title },
    ]);
  },
  methods: {
    async initialise() {
      this.getPrograms();
      this.getDegrees();
    },
    async getPrograms() {
      await this.$axios
        .get("programs")
        .then((res) => {
          const response = res.data.data;
          this.programs = response
            .filter((c) => c.degree_id == this.degree_id)
            .sort((a, b) => b.id - a.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getDegrees() {
      await this.$axios
        .get("degrees")
        .then((res) => {
          const response = res.data.data;
          const response_proc = response.filter(
            (el) => el.id == this.degree_id
          );
          this.degrees = response_proc;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async updateDegree(data) {
      await this.$axios
        .put("degrees/" + data.id, { degree: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Degree updated successfully",
            color: "success",
          });
          this.resetDegreeValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async createProgram(data) {
      await this.$axios
        .post("programs", { program: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Programme created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateProgram(data) {
      await this.$axios
        .put("programs/" + data.id, { program: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Programme updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      if (this.key == "D")
        this.updateDegree({
          id: this.currentItem.id,
          active: !this.currentItem.active,
        });
      if (this.key == "P")
        this.updateProgram({
          id: this.currentItem.id,
          active: !this.currentItem.active,
        });
    },
    openConfirm(key, item) {
      this.key = key;
      this.showDialog = true;
      this.currentItem = { ...item };
    },
    showActiveStatus(item) {
      return item.active ? "Active" : "Inactive";
    },

    edit(item) {
      this.program = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    editDegree(item) {
      this.degree = { ...item };
      this.editDegreeMode = true;
      this.degreeDialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.program = {};
      this.currentItem = {};
    },
    resetDegreeValues() {
      this.editDegreeMode = false;
      this.degreeDialog = false;
      this.degree = {};
    },
    showLevel(item) {
      return this.levels.find((i) => i.id === item.level)?.name;
    },
    getDuration(item) {
      const durationObj = this.durations.find(
        (p) => p.id == item.duration_type
      );
      if (!durationObj) return ""; // Handle invalid duration_type

      const name = durationObj.name;
      return item.duration > 1 ? `${name}s` : name;
    },

    getProgramName(item) {
      return (
        (item.degree?.short_name || "") +
        (item.specialization ? ` - ${item.specialization}` : "")
      );
    },
    getDurationType(item) {
      return item.duration + " " + this.getDuration(item);
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const degree = this.getProgramName(item);
      const duration = this.getDurationType(item);
      const activeStatus = this.showActiveStatus(item.active);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        degree.toLowerCase().includes(search.toLowerCase()) ||
        duration.toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
